import * as React from 'react';
import { useInput } from '@mui/base';
import { styled } from '@mui/system';
import { InputLabel } from "@mui/material";

const StyledInputElement = styled('input')`
  width: 100%;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3A415A;
  background: #fff;
  border: 1px solid #939599;
  border-radius: 5px;
  padding: 9px 15px;

  &:focus {
    outline: 1px solid #000;
  }

  &.error {
    border: 1px solid #d90208;
  }
`;

const CustomInputElement = React.forwardRef(function CustomInput(props, ref) {
  const { getRootProps, getInputProps } = useInput(props, ref);

  return (
    <div {...getRootProps()}>
      {props.label &&
      <InputLabel sx={{marginBottom: '8px', color: '#3A415A'}}>{props.label} {props.required && <> *</>}</InputLabel>
      }
      <StyledInputElement {...props} {...getInputProps()} placeholder={props.placeholder} />
    </div>
  );
});

export default function CustomInput(props) {
  return <CustomInputElement {...props} />;
}
